@if (categories()) {
  <div ngbAccordion [closeOthers]="false">
    @for (category of categories(); track category) {
      @if (category.subCategories && (category.subCategories!.items.length > 0)) {
        <div ngbAccordionItem [collapsed]="! catPath().includes(category.id)">
          <h2 ngbAccordionHeader class="lvl{{ level() }}">
            <button (click)="bcService.trackCategoryMenuExpand(category)" ngbAccordionButton>{{ category.name }}</button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <div class="link-wrap {{ 'lvl' + ( level() + 1 ) }}">
                <a class="accordion-button" routerLinkActive="active" [routerLink]="[ category.fullPath ]">
                  {{ category.name }} entdecken
                </a>
              </div>
              <gea-shop-navigation-category-accordion
                [categories]="category.subCategories"
                [level]="level() + 1"
                />
            </div>
          </div>
        </div>
      } @else {
        <div class="link-wrap {{ 'lvl' + level() }}">
          <a [aria-label]="ariaLabel(category)" class="accordion-button" routerLinkActive="active" [routerLink]="[ category.fullPath ]">
            {{ category.name }}
          </a>
        </div>
      }
    }
  </div>
}